class SessionService {
    /*@ngInject*/
    constructor($window, $timeout, EventService, $log) {
        this.$window = $window;
        this.$timeout = $timeout;
        this.eventService = EventService;
        this.$log = $log;

        this.debug = false;
    }
    set(key,value,useLocal=false){
        let toSave = value;
        if(typeof value==='object'){
            toSave = angular.toJson(value);
        }
        if(useLocal){
            this.$window.localStorage.setItem(key,toSave);
        }else {
            this.$window.sessionStorage.setItem(key, toSave);
        }
        this.eventService.broadcast('session:'+key,value);
    }
    get(key,defaultValue=null){
        let value = this.$window.sessionStorage.getItem(key);
        if(value===null){
            value = this.$window.localStorage.getItem(key);
        }
        if(value===null){
            return defaultValue;
        }
        try{
            return JSON.parse(value);
        }catch(e){
            return value;
        }
    }
    inSessionStorage(key){
        let value = this.$window.sessionStorage.getItem(key);
        return value!==null;
    }
    inLocalStorage(key){
        let value = this.$window.localStorage.getItem(key);
        return value!==null;
    }
    remove(key){
        if(this.$window.sessionStorage.getItem(key)) {
            this.$window.sessionStorage.removeItem(key);
            this.eventService.broadcast('session:' + key, null);
        }
        if(this.$window.localStorage.getItem(key)) {
            this.$window.localStorage.removeItem(key);
            this.eventService.broadcast('session:' + key, null);
        }
    }
    clear(){
        this.$window.sessionStorage.clear();
    }
}
export default SessionService;


// WEBPACK FOOTER //
// ./public/app/services/session.service.js